<div class="p-2">
	@if (loading) {
	<mat-spinner diameter="32"></mat-spinner>
	} @else if (settings) {
	<div class="settings-form">
		<mat-slide-toggle [(ngModel)]="settings.autoAcceptEnabled">Автоматски прифати кога сигурноста е над X%</mat-slide-toggle>

		<mat-form-field class="mt-3">
			<mat-label>Праг за автоматско прифаќање (%)</mat-label>
			<input matInput type="number" min="0" max="100" [(ngModel)]="settings.autoAcceptThreshold" [disabled]="!settings.autoAcceptEnabled" />
		</mat-form-field>

		<mat-form-field class="mt-3">
			<mat-label>Број примери во промптот</mat-label>
			<input matInput type="number" min="1" max="50" [(ngModel)]="settings.examplesInPrompt" />
		</mat-form-field>

		<div class="mt-3">
			<button mat-flat-button color="primary" [disabled]="saving" (click)="save()">Зачувај</button>
		</div>
	</div>

	<div class="settings-form mt-4">
		<h3>Исклучени профили — за сите клиенти</h3>
		<p class="text-muted small">Објавите од овие профили/групи се отфрлаат автоматски за секој клиент, без AI (спам/непожелни страници).</p>
		<div class="excluded-list">
			@for (p of globalExcludedProfiles; track p.id) {
			<div class="excluded-row">
				@if (editingExcludedId !== p.id) {
				<span class="excluded-label" [title]="p.label || p.slug || p.externalId || p.sourceLink">{{ p.label || p.slug || p.externalId || p.sourceLink }}</span>
				<span class="text-muted small">({{ p.profileType === 'GROUP' ? 'група' : 'профил' }})</span>
				<mat-icon class="edit-icon" (click)="startExcludedEdit(p)" title="Измени име">edit</mat-icon>
				<mat-icon class="remove-icon" (click)="deleteGlobalExcludedProfile(p.id, p.label || p.slug || p.sourceLink || '')">close</mat-icon>
				} @else {
				<input class="inline-edit-input flex-grow-1" [(ngModel)]="editingExcludedLabel" placeholder="Име" (keydown.enter)="saveExcludedEdit()" (keydown.escape)="cancelExcludedEdit()" />
				<mat-icon class="edit-icon" (click)="saveExcludedEdit()" title="Зачувај">check</mat-icon>
				<mat-icon class="remove-icon" (click)="cancelExcludedEdit()" title="Откажи">close</mat-icon>
				}
			</div>
			}
			@if (globalExcludedProfiles.length === 0) {
			<p class="text-muted">Нема глобално исклучени профили.</p>
			}
		</div>
		<div class="d-flex gap-2 mt-2">
			<mat-form-field class="flex-grow-1">
				<mat-label>Facebook линк</mat-label>
				<input matInput [(ngModel)]="newExcludedLink" placeholder="https://www.facebook.com/..." />
			</mat-form-field>
			<mat-form-field>
				<mat-label>Име (опционално)</mat-label>
				<input matInput [(ngModel)]="newExcludedLabel" />
			</mat-form-field>
			<button mat-flat-button color="primary" (click)="addGlobalExcludedProfile()">Исклучи</button>
		</div>
	</div>
	}
</div>
